<template>
  <component :is="componentsByType[pageSettingType]" :key="pageSettingId" />
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { defineAsyncComponent, markRaw, ref } from 'vue'
import { useSectionsStore } from '@/stores/section'

const sectionsStore = useSectionsStore()
const { pageSettingType, pageSettingId } = storeToRefs(sectionsStore)

const componentsByType = ref({
  NEWS: markRaw(defineAsyncComponent(() => import('@/views/ArticlePage.vue'))),
  'NEWS-FLOOD-2024': markRaw(defineAsyncComponent(() => import('@/views/ArticlePageFlood.vue'))),
  REGULATIONS: markRaw(defineAsyncComponent(() => import('@/views/RegulationsPage.vue'))),
  IMAGE_GALLERY: markRaw(defineAsyncComponent(() => import('@/views/GalleryPage.vue'))),
  DIRECTORY_REPORTS: markRaw(defineAsyncComponent(() => import('@/views/RaportPage.vue'))),
  DIRECTORY_TAG: markRaw(defineAsyncComponent(() => import('@/views/TagsPage.vue'))),
  DIRECTORY: markRaw(defineAsyncComponent(() => import('@/views/MainCategoryPage.vue'))),
  DIRECTORY_WEBSITE: markRaw(
    defineAsyncComponent(() => import('@/views/ProgramDirectoryPage.vue'))
  ),
  DIRECTORY_GALLERY: markRaw(defineAsyncComponent(() => import('@/views/MainCategoryPage.vue'))),
  DIRECTORY_GRID: markRaw(defineAsyncComponent(() => import('@/views/MainCategoryGridPage.vue'))),
  DIRECTORY_REPORT_SIDEBAR: markRaw(
    defineAsyncComponent(() => import('@/views/MainCategoryPage.vue'))
  ),
  DIRECTORY_SIDEBAR: markRaw(defineAsyncComponent(() => import('@/views/MainCategoryPage.vue'))),
  DIRECTORY_FORM_SIDEBAR: markRaw(
    defineAsyncComponent(() => import('@/views/MainCategoryPage.vue'))
  ),
  EDITOR: markRaw(defineAsyncComponent(() => import('@/views/EditorPage.vue'))),
  VIDEO: markRaw(defineAsyncComponent(() => import('@/views/VideoPage.vue'))),
  DIRECTORY_REVIEWS: markRaw(defineAsyncComponent(() => import('@/views/OpinionsPage.vue'))),
  DIRECTORY_SERIES: markRaw(defineAsyncComponent(() => import('@/views/ProgramsPage.vue'))),
  WEBSITE: markRaw(defineAsyncComponent(() => import('@/views/ProgramPage.vue'))),
  WEBSITE_HOMEPAGE: markRaw(defineAsyncComponent(() => import('@/views/ProgramDirectoryPageWebsite.vue'))),
  CONTACT: markRaw(defineAsyncComponent(() => import('@/views/ContactPage.vue'))),
  'ELECTIONS-IFRAME': markRaw(
    defineAsyncComponent(() => import('@/views/elections/ElectionsIframePage.vue'))
  ),
  "ELECTIONS-LOCAL-IFRAME": markRaw(defineAsyncComponent(() => import('@/views/elections/ElectionsIframePageLocal.vue'))),
  DIRECTORY_INSTITUTION: markRaw(
    defineAsyncComponent(() => import('@/views/Politics/PoliticsDetalPartiesPage.vue'))
  ),
  DIRECTORY_POLITICIAN_PARTY: markRaw(
    defineAsyncComponent(() => import('@/views/Politics/PoliticsDetalPartiesPage.vue'))
  ),
  POLITICIAN: markRaw(defineAsyncComponent(() => import('@/views/Politics/PoliticDetalPage.vue'))),
  DIRECTORY_POLITICIANS_SG: markRaw(
    defineAsyncComponent(() => import('@/views/Politics/PoliticsPage.vue'))
  ),
  DIRECTORY_INSTITUTION_MEMBERS: markRaw(
    defineAsyncComponent(() => import('@/views/Politics/PoliticsInstitutionDetalPage.vue'))
  ),
  DIRECTORY_POLITICIAN_PARTY_MEMBERS: markRaw(
    defineAsyncComponent(() => import('@/views/Politics/PoliticsPartyDetalPage.vue'))
  ),
  DIRECTORY_ELECTIONS: markRaw(
    defineAsyncComponent(() => import('@/views/elections/ElectionsPage.vue'))
  ),
  SG: markRaw(defineAsyncComponent(() => import('@/views/GeneratePage.vue')))
})
</script>
